// 판정용 origin — 실제 호스트와 무관하다. 경로를 여기에 붙여 풀었을 때 이 origin 을
// 벗어나면 앱 밖이다.
const BASE = 'https://app.invalid';

/**
 * 밖에서 온 경로(딥링크·history state)를 앱 안의 경로(`pathname + search + hash`)로
 * 정규화한다. 브라우저가 다른 origin 으로 푸는 입력은 `null`.
 *
 * 문자열 검사로는 못 막는다 — URL 파서는 `//host` 뿐 아니라 `/\host`·`/\t/host` 도
 * `//host` 로 읽는다. 그런 주소를 navigate 하면 react-router 7 은 `pushState` 가 거부하는 순간
 * `location.assign(url)` 로 폴백해(react-router `createBrowserHistory` push) 그 페이지를 WebView 에
 * 브리지째 띄운다. 그래서 판정도 같은 URL 파서에 맡긴다.
 */
export const toAppPath = (raw: string): string | null => {
  let url: URL;
  try {
    url = new URL(raw, BASE);
  } catch {
    return null;
  }
  if (url.origin !== BASE) {
    return null;
  }
  // 라우터는 겹친 슬래시를 접어 매칭한다(`resolvePath`) — 판정도 그 모양으로 한다.
  // 안 그러면 `/.//setup` 이 `//setup` 으로 남아 `/setup` 검사를 비껴간다.
  return url.pathname.replace(/\/{2,}/g, '/') + url.search + url.hash;
};

const decodeSegment = (segment: string): string => {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
};

/**
 * `path`(`toAppPath` 결과)가 `route` 이거나 그 아래인가 — react-router 가 매칭하는 기준으로
 * 본다: 세그먼트마다 디코드하고 대소문자를 가리지 않는다(`/%73etup` 도 `/SETUP` 도 `/setup`).
 * `.`·`..` 세그먼트와 겹친 슬래시는 `toAppPath` 가 이미 풀었다.
 */
export const isUnderRoute = (path: string, route: string): boolean => {
  const pathname = path.split(/[?#]/, 1)[0];
  const decoded = pathname
    .split('/')
    .map(decodeSegment)
    .join('/')
    .toLowerCase();
  const root = route.toLowerCase();
  return decoded === root || decoded.startsWith(`${root}/`);
};
